import {createAction} from 'redux-actions'
import {createActionObject} from '../../../redux/utils'

export default function({
    actionTypes: {
        CLEAR_CUSTOMERS,
        CLEAR_PROJECTS,
        CLEAR_TASKS,
        LOADED_SET,
        CUSTOMERS_LOADED_SET,
        PROJECTS_LOADED_SET,
        TASKS_LOADED_SET,
        EDITING_USER_ID_SET,
        EDITING_LEVEL_SET,
        PROJECTS_TASKS_COUNT_CLEAR,
        CUSTOMERS_TASKS_COUNT_CLEAR,
        CUSTOMERS_PROJECTS_COUNT_CLEAR,
        LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS,
        LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE,
        LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS,
        LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE,
        LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS,
        LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE,
        CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS,
        CHANGE_CUSTOMER_ASSIGNMENT_FAILURE,
        CHANGE_PROJECT_ASSIGNMENT_SUCCESS,
        CHANGE_PROJECT_ASSIGNMENT_FAILURE,
        CHANGE_TASK_ASSIGNMENT_SUCCESS,
        CHANGE_TASK_ASSIGNMENT_FAILURE,
        CHANGE_ALL_ASSIGNMENTS_SUCCESS,
        CUSTOMERS_SEARCH_TEXT_SET,
        CUSTOMERS_SEARCH_OPEN_SET,
        PROJECTS_SEARCH_OPEN_SET,
        PROJECTS_SEARCH_TEXT_SET,
        TASKS_SEARCH_OPEN_SET,
        TASKS_SEARCH_TEXT_SET,
    }
}) {
    const setLoaded = createAction(LOADED_SET)
    const setCustomersLoaded = createAction(CUSTOMERS_LOADED_SET)
    const setProjectsLoaded = createAction(PROJECTS_LOADED_SET)
    const setTasksLoaded = createAction(TASKS_LOADED_SET)

    const openEditor = userId => dispatch => {
        dispatch(clearAll())
        dispatch(resetSearchState())
        dispatch(createActionObject(EDITING_USER_ID_SET, userId))
        dispatch(createActionObject(EDITING_LEVEL_SET, {
            customerId: null,
            projectId: null
        }))
        dispatch(setCustomersLoaded(false))
    }

    const closeEditor = () => dispatch => {
        dispatch(createActionObject(EDITING_USER_ID_SET, null))
    }

    const resetSearchState = () => dispatch => {
        dispatch(createActionObject(CUSTOMERS_SEARCH_OPEN_SET, false))
        dispatch(createActionObject(CUSTOMERS_SEARCH_TEXT_SET, ''))
        dispatch(createActionObject(PROJECTS_SEARCH_OPEN_SET, false))
        dispatch(createActionObject(PROJECTS_SEARCH_TEXT_SET, ''))
        dispatch(createActionObject(TASKS_SEARCH_OPEN_SET, false))
        dispatch(createActionObject(TASKS_SEARCH_TEXT_SET, ''))
    }

    const selectCustomer = customerId => dispatch => {
        dispatch(createActionObject(CLEAR_PROJECTS))
        dispatch(createActionObject(PROJECTS_SEARCH_OPEN_SET, false))
        dispatch(createActionObject(PROJECTS_SEARCH_TEXT_SET, ''))
        dispatch(createActionObject(EDITING_LEVEL_SET, {
            customerId,
            projectId: null
        }))
    }

    const selectProject = projectId => dispatch => {
        dispatch(createActionObject(CLEAR_TASKS))
        dispatch(createActionObject(TASKS_SEARCH_OPEN_SET, false))
        dispatch(createActionObject(TASKS_SEARCH_TEXT_SET, ''))
        dispatch(createActionObject(EDITING_LEVEL_SET, {
            projectId
        }))
    }

    const deselectCustomer = () => dispatch => {
        dispatch(createActionObject(EDITING_LEVEL_SET, {
            customerId: null,
            projectId: null
        }))
    }

    const deselectProject = () => dispatch => {
        dispatch(createActionObject(EDITING_LEVEL_SET, {
            projectId: null
        }))
    }

    const loadCustomersSuccess = (data, loadLimit) => (dispatch) => {
        const customers = data['customers']
        dispatch(createActionObject(LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS, {
            customerIds: customers.map(c => c['customer']['id']),
            canWorkCustomerIds: customers.filter(c => c['canWork']).map(c => c['customer']['id']),
            canManageCustomerIds: customers.filter(c => c['canManage']).map(c => c['customer']['id']),
            canManageCustomerExcludeSelfIds: customers.filter(c => c['canManageExcludeSelf']).map(c => c['customer']['id']),
            viewerCanManageCustomerIds: customers.filter(c => c['viewerCanManage']).map(c => c['customer']['id']),
            projectCounts: customers.reduce((acc, c) => ({...acc, [c['customer']['id']]: c['projectsCount']}), {}),
            taskCounts: customers.reduce((acc, c) => ({...acc, [c['customer']['id']]: c['tasksCount']}), {}),
            futureCustomersAssigned: data['futureCustomersAssigned'],
            someCustomersOrLowerAssigned: data['someCustomersOrLowerAssigned'],
            allCustomersAssigned: data['allCustomersAssigned']
        }))
        dispatch(setCustomersLoaded(customers.length < loadLimit))
    }

    const loadCustomersFailure = createAction(LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE)

    const loadProjectsSuccess = (data, loadLimit) => dispatch => {
        const projects = data['projects']
        dispatch(createActionObject(LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS, {
            canManageParentCustomer: data['canManageParentCustomer'],
            projectIds: projects.map(p => p['project']['id']),
            canWorkProjectIds: projects.filter(p => p['canWork']).map(p => p['project']['id']),
            canManageProjectIds: projects.filter(p => p['canManage']).map(p => p['project']['id']),
            canManageProjectExcludeSelfIds: projects.filter(c => c['canManageExcludeSelf']).map(c => c['project']['id']),
            viewerCanManageProjectIds: projects.filter(p => p['viewerCanManage']).map(p => p['project']['id']),
            taskCounts: projects.reduce((acc, p) => ({...acc, [p['project']['id']]: p['tasksCount']}), {}),
            futureProjectsAssigned: data['futureProjectsAssigned'],
            someProjectsOrLowerAssigned: data['someProjectsOrLowerAssigned'],
            allProjectsAssigned: data['allProjectsAssigned']
        }))

        dispatch(setProjectsLoaded(projects.length < loadLimit))
    }

    const loadProjectsFailure = createAction(LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE)

    const loadTasksSuccess = (data, loadLimit) => dispatch => {
        const tasks = data['tasks']
        dispatch(createActionObject(LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS, {
            canManageParentCustomer: data['canManageParentCustomer'],
            canManageParentProject: data['canManageParentProject'],
            taskIds: tasks.map(t => t['task']['id']),
            canWorkTaskIds: tasks.filter(t => t['canWork']).map(t => t['task']['id']),
            canManageTaskIds: tasks.filter(t => t['canManage']).map(t => t['task']['id']),
            futureTasksAssigned: data['futureTasksAssigned'],
            someTasksAssigned: data['someTasksAssigned'],
            allTasksAssigned: data['allTasksAssigned']
        }))

        dispatch(setTasksLoaded(tasks.length < loadLimit))
    }

    const loadTasksFailure = createAction(LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE)

    const changeCustomerAssignmentSuccess = (customerId, canWork, canManage, someAssigned, allAssigned) => dispatch => {
        // TODO: implement on server
        dispatch(createActionObject(CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS, {
            customerId,
            canWork,
            canManage,
            someAssigned,
            allAssigned,
        }))
    }

    const changeCustomerAssignmentFailure = (customerId, assigned, error) => createActionObject(CHANGE_CUSTOMER_ASSIGNMENT_FAILURE, {
        customerId,
        assigned,
        error
    })

    const changeProjectAssignmentSuccess = (projectId, canWork, canManage, someAssigned, allAssigned) => dispatch => {
        // TODO: implement on server
        dispatch(createActionObject(CHANGE_PROJECT_ASSIGNMENT_SUCCESS, {
            projectId,
            canWork,
            canManage,
            someAssigned,
            allAssigned,
        }))
        dispatch(createActionObject(CLEAR_CUSTOMERS))
    }

    const changeProjectAssignmentFailure = (projectId, assigned, error) => createActionObject(CHANGE_PROJECT_ASSIGNMENT_FAILURE, {
        projectId,
        assigned,
        error
    })

    const changeTaskAssignmentSuccess = (taskId, canWork, canManage, someAssigned, allAssigned) => dispatch => {
        // TODO: implement on server
        dispatch(createActionObject(CHANGE_TASK_ASSIGNMENT_SUCCESS, {
            taskId,
            canWork,
            canManage,
            someAssigned,
            allAssigned,
        }))
        dispatch(createActionObject(CLEAR_CUSTOMERS))
        dispatch(createActionObject(CLEAR_PROJECTS))
    }

    const changeTaskAssignmentFailure = (taskId, assigned, error) => createActionObject(CHANGE_TASK_ASSIGNMENT_FAILURE, {
        taskId,
        assigned,
        error
    })

    const assignAllCustomersSuccess = () => dispatch => {
        dispatch(createActionObject(CHANGE_ALL_ASSIGNMENTS_SUCCESS))
        dispatch(createActionObject(CLEAR_CUSTOMERS))
    }

    const assignAllProjectsSuccess = () => dispatch => {
        dispatch(createActionObject(CHANGE_ALL_ASSIGNMENTS_SUCCESS))
        dispatch(createActionObject(CLEAR_CUSTOMERS))
        dispatch(createActionObject(CLEAR_PROJECTS))
    }

    const assignAllTasksSuccess = () => dispatch => {
        dispatch(createActionObject(CHANGE_ALL_ASSIGNMENTS_SUCCESS))
        dispatch(createActionObject(CLEAR_CUSTOMERS))
        dispatch(createActionObject(CLEAR_PROJECTS))
        dispatch(createActionObject(CLEAR_TASKS))
    }

    const changeCustomersSearchText = text => dispatch => {
        dispatch(createActionObject(CUSTOMERS_SEARCH_OPEN_SET, true))
        dispatch(createActionObject(CUSTOMERS_SEARCH_TEXT_SET, text))
        dispatch(createActionObject(CLEAR_CUSTOMERS))
        dispatch(setLoaded(false))
    }

    const clearCustomersSearchText = () => dispatch => {
        dispatch(createActionObject(CUSTOMERS_SEARCH_OPEN_SET, false))
        dispatch(createActionObject(CUSTOMERS_SEARCH_TEXT_SET, ''))
        dispatch(createActionObject(CLEAR_CUSTOMERS))
        dispatch(setLoaded(false))
    }

    const changeProjectsSearchText = text => dispatch => {
        dispatch(createActionObject(PROJECTS_SEARCH_OPEN_SET, true))
        dispatch(createActionObject(PROJECTS_SEARCH_TEXT_SET, text))
        dispatch(createActionObject(CLEAR_PROJECTS))
        dispatch(setLoaded(false))
    }

    const clearProjectsSearchText = () => dispatch => {
        dispatch(createActionObject(PROJECTS_SEARCH_OPEN_SET, false))
        dispatch(createActionObject(PROJECTS_SEARCH_TEXT_SET, ''))
        dispatch(createActionObject(CLEAR_PROJECTS))
        dispatch(setLoaded(false))
    }

    const changeTasksSearchText = text => dispatch => {
        dispatch(createActionObject(TASKS_SEARCH_OPEN_SET, true))
        dispatch(createActionObject(TASKS_SEARCH_TEXT_SET, text))
        dispatch(createActionObject(CLEAR_TASKS))
        dispatch(setLoaded(false))
    }

    const clearTasksSearchText = () => dispatch => {
        dispatch(createActionObject(TASKS_SEARCH_OPEN_SET, false))
        dispatch(createActionObject(TASKS_SEARCH_TEXT_SET, ''))
        dispatch(createActionObject(CLEAR_TASKS))
        dispatch(setLoaded(false))
    }

    const clearProjectsTasksCount = (projectIds) => dispatch => {
        dispatch(createActionObject(PROJECTS_TASKS_COUNT_CLEAR, projectIds))
    }

    const clearCustomersTasksCount = (customerIds) => dispatch => {
        dispatch(createActionObject(CUSTOMERS_TASKS_COUNT_CLEAR, customerIds))
    }

    const clearCustomersProjectsCount = (customerIds) => dispatch => {
        dispatch(createActionObject(CUSTOMERS_PROJECTS_COUNT_CLEAR, customerIds))
    }

    const clearAll = () => dispatch => {
        dispatch(createActionObject(CLEAR_CUSTOMERS))
        dispatch(createActionObject(CLEAR_PROJECTS))
        dispatch(createActionObject(CLEAR_TASKS))
    }

    return {
        clearAll,
        setCustomersLoaded,
        setProjectsLoaded,
        setTasksLoaded,
        openEditor,
        closeEditor,
        selectCustomer,
        selectProject,
        deselectCustomer,
        deselectProject,
        loadCustomersSuccess,
        loadCustomersFailure,
        loadProjectsSuccess,
        loadProjectsFailure,
        loadTasksSuccess,
        loadTasksFailure,
        changeCustomerAssignmentSuccess,
        changeCustomerAssignmentFailure,
        changeProjectAssignmentSuccess,
        changeProjectAssignmentFailure,
        changeTaskAssignmentSuccess,
        changeTaskAssignmentFailure,
        assignAllCustomersSuccess,
        assignAllProjectsSuccess,
        assignAllTasksSuccess,
        clearProjectsTasksCount,
        clearCustomersTasksCount,
        clearCustomersProjectsCount,
        changeCustomersSearchText,
        clearCustomersSearchText,
        changeProjectsSearchText,
        clearProjectsSearchText,
        changeTasksSearchText,
        clearTasksSearchText,
        resetSearchState
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsEditor/actionsGenerator.js